import { SIDEBAR_MENU_LINK } from '@/layouts/sidebar';
import { Button } from '@nextui-org/react';
import Link from 'next/link';
import { useRouter, useSearchParams } from 'next/navigation';
import React, { useRef } from 'react';
import { KEY_SORT } from '../constants';
import ToolbarFilter from './action';
import CategoryTool from './category';
import ToolbarSearch from './search';

const ToolBar: React.FC = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const refSearch = useRef<any>(null);
  const handleClearFilter = () => {
    if (refSearch.current) refSearch.current.value = '';
    router.replace(SIDEBAR_MENU_LINK.workflow, { scroll: false });
  }
  const hasQuery = !!searchParams.get(KEY_SORT.CREATED) || !!searchParams.get(KEY_SORT.LIKE) || !!searchParams.get(KEY_SORT.RUN);

  return (
    <>
      <div className="flex items-center justify-between sm:flex-wrap">
        <div className="flex items-center sm:w-full">
          <ToolbarFilter />
          {hasQuery && (
            <Button
              className="ml-2 rounded-full border-1 border-gray-200 bg-white text-[14px] h-10 w-10 sm:h-[36px] sm:w-[36px] font-medium"
              onClick={handleClearFilter}
            >
              Clear all
            </Button>
          )}
          <div aria-checked={hasQuery} className="ml-2 sm:w-[calc(100%-44px)] aria-checked:sm:w-[calc(100%-44px-88px)]">
            <ToolbarSearch refSearch={refSearch} />
          </div>
        </div>
        <div className="sm:hidden">
          <Link 
            href="https://docs.google.com/forms/d/1SdMQDMaFlkDcbysFaaC6xeNmlazY6ldHwhMVEUx4O5Q" 
            target="_blank"
            className="h-[40px] sm:h-[36px] rounded-full bg-primary text-white flex items-center px-4 text-[14px] gap-1"
          >
              <span className="text-[22px] font-light">+</span> 
              <span className="font-medium">ComfyFlow</span>
          </Link>
        </div>
      </div>
      <CategoryTool />
    </>
  );
}

export default ToolBar;